import PitchComparison from './PitchComparison';

export default PitchComparison;
